export const UI_SHIFT_PROJECT = "ui_shift_project"
